import { reactive } from 'vue'
import actions from '@/store/license/actions'
import state from '@/store/license/state'
import getters from '@/store/license/getters'

export const licenseModule = {
    state: reactive(state),
    actions,
    getters,
}
